export default __webpack_public_path__ + "static/media/Clínica-Zona-Sul.c98b94bf.png";